
import React from 'react';
import {observer} from 'mobx-react';
import CollectionView from 'lib/collection/collection-view';
import FileUploadListItemView from '../file-upload-list-item-view';


@observer
class FileUploadListView extends React.Component {
    onRemove = (data) => () => {
        this.props.field.data.remove(data)
        .then((result) => {
            if (this.props.onCancel) {
                this.props.onCancel(result);
            }
        })
        .catch(err => {
            if (this.props.onCancelError) {
                this.props.onCancelError(err);
            }
        });

        return null;
    }

    element = (data) => {
        const {key, file, progress, uploading, error, upload} = data;
        let name = '';
        if (file) {
            ({name} = file);
        }

        return (
            <FileUploadListItemView
                key={key}
                thumbnail={React.cloneElement(this.props.thumbnail, {...data})}
                name={name}
                progress={progress}
                uploading={uploading}
                error={error}
                onRemove={this.onRemove(data)}
                onRetry={upload}
                />
        );
    }

    move = (from, to) => {
        const items = this.props.field.data.fields.slice();
        const value = items[from];

        items.splice(from, 1);
        items.splice(to, 0, value);

        this.props.field.data.fields.replace(items);

    }

    itemKey = ({key}) => key;
    isDraggable = () => this.props.field.data.fields.length > 1;

    render() {
        const {field: {data}} = this.props;

        return (
            <CollectionView
                items={data.fields}
                element={this.element}
                move={this.move}
                itemKey={this.itemKey}
                isDraggable={this.isDraggable}
                height={40}
                />
        );
    }
}

export default FileUploadListView;
